import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import {
	Button,
	Jumbotron
} from 'react-bootstrap';

export default class Home extends Component {
	render() {
		const { isAuthenticated } = this.props.auth;
		if (isAuthenticated()) {
			return <Jumbotron style={{padding: 60}}>
				<h1>You've logged in</h1>
				<p>You can now view your PTO balance</p>
				<Link to="/profile"><Button bsStyle="primary">Go To Profile</Button></Link>
			</Jumbotron>
		}

		return (
			<Jumbotron style={{padding: 60}}>
				<h1>Login to view your PTO</h1>
			</Jumbotron>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.js